import config from 'config/config-env';

export const downloadOrders = async (url: string) => {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.setAttribute('href', `${config.cablesUrl}${url}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
